import { Injectable } from "@angular/core";
import { CurrentRouteService } from "@modules/common/services/current-route.service";

/**
 * Service to get the participant id from the current route, if there is one.
 */
@Injectable({
    providedIn: 'root',
})
export class GetParticipantIdFromRouteService {
    constructor(private readonly _currentRouteService: CurrentRouteService) { }

    /**
     * Returns the participant id from the current route, or undefined if the current route
     * does not have a participant id.
     */
    public getParticipantIdFromRoute(): number | undefined {
        const participantIdString = this._currentRouteService.getCurrentRoute().params.participantId;
        if (!participantIdString) {
            return undefined;
        }
        return parseInt(participantIdString);
    }
}